import { discountSettingsSchema } from "@redotech/redo-model/discount/discount-db-parser";
import { TrackingPageDiscountSource } from "@redotech/redo-model/generated-discount-code-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const generateDiscountCode = {
  name: "generateDiscountCode" as const,
  input: z.object({
    discountId: zExt.objectId(),
    orderId: z.string().optional(),
    source: z.enum(TrackingPageDiscountSource),
  }),
  output: z.object({
    discountCode: z.string(),
    discountSettings: discountSettingsSchema.optional(),
  }),
};
